import { colors } from '@airship-platform/jam-design-tokens';
import { SvgIconProps } from '@mui/material';
import React from 'react';

interface AirshipThemeIconProps extends SvgIconProps {
  primary?: string;
  secondary?: string;
  accent?: string;
}

const AirshipThemeIcon: React.FC<AirshipThemeIconProps> = ({
  primary = colors.blue[800],
  secondary = colors.blue[300],
  accent = colors.blue[200],
  ...props
}) => (
  <svg
    width="80"
    height="32"
    viewBox="0 0 80 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.75"
      y="1.25"
      width="29.5"
      height="29.5"
      rx="14.75"
      fill={primary}
      stroke="white"
      strokeWidth="1.5"
    />
    <rect
      x="25.25"
      y="1.25"
      width="29.5"
      height="29.5"
      rx="14.75"
      fill={secondary}
      stroke="white"
      strokeWidth="1.5"
    />
    <rect
      x="49.75"
      y="1.25"
      width="29.5"
      height="29.5"
      rx="14.75"
      fill={accent}
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export default AirshipThemeIcon;
